export default __webpack_public_path__ + "static/media/createsend.7063484f.png";